import { defineComponent as u, ref as i, resolveComponent as w, openBlock as v, createElementBlock as d, normalizeClass as t, withDirectives as a, createVNode as s, withKeys as l, vShow as f, renderSlot as g, createCommentVNode as p } from "vue";
import h from "../VIconButton/VIconButton.js";
import { getComputedStyleValue as I } from "../../../utils/getComputedStyleValue.js";
import { _ as m } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../VIcon/VIcon.js";
const b = u({
  name: "VNavigationArrows",
  emits: ["navigation-arrows:click-left", "navigation-arrows:click-right"],
  components: {
    VIconButton: h
  },
  props: {
    showLeftArrow: {
      type: Boolean,
      default: !1
    },
    showRightArrow: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: () => !0
    },
    useLeftPaddedArrow: {
      type: Boolean,
      default: !1
    },
    isWrapper: {
      type: Boolean,
      default: !1
    },
    navigationArrowsAriaLabel: {
      type: String,
      default: null
    },
    hasBorder: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      leftIconIsHovered: !1,
      leftIconIsInFocus: !1,
      rightIconIsHovered: !1,
      rightIconIsInFocus: !1
    };
  },
  setup() {
    const e = i(null), o = i(null);
    return {
      rightArrowRef: e,
      leftArrowRef: o,
      getComputedStyleValue: I
    };
  },
  methods: {
    handleFocus(e, o) {
      e.target.matches(":focus-visible") ? (o === "left" && (this.leftIconIsInFocus = !0), o === "right" && (this.rightIconIsInFocus = !0)) : (o === "left" && (this.leftIconIsInFocus = !1), o === "right" && (this.rightIconIsInFocus = !1));
    }
  }
});
function y(e, o, A, c, $, F) {
  const n = w("VIconButton");
  return v(), d("div", {
    class: t(["hobi-navigation-arrows tw-flex tw-items-center tw-relative", { "hobi-wrapper": e.isWrapper }])
  }, [
    a(s(n, {
      "aria-label": e.navigationArrowsAriaLabel,
      ref: "leftArrowRef",
      symbol: "chevron-left",
      color: e.leftIconIsHovered || e.leftIconIsInFocus ? e.getComputedStyleValue("--hobi-color-white") : e.getComputedStyleValue("--hobi-color-grey-900"),
      size: "20",
      class: t(["hobi-navigation-arrow hobi-navigation-arrow--left tw-absolute tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-left-0", {
        "hobi-wrapper": e.isWrapper,
        "hobi-navigation-arrow--leftPadded": e.useLeftPaddedArrow,
        "hobi-navigation-arrow--has-border": e.hasBorder,
        "hobi-navigation-arrow--has-hover": e.leftIconIsHovered
      }]),
      onClick: o[0] || (o[0] = (r) => e.$emit("navigation-arrows:click-left")),
      onKeypress: o[1] || (o[1] = l((r) => e.$emit("navigation-arrows:click-left"), ["enter"])),
      onFocus: o[2] || (o[2] = (r) => e.handleFocus(r, "left")),
      onBlur: o[3] || (o[3] = (r) => e.handleFocus(r, "left")),
      onMouseover: o[4] || (o[4] = (r) => e.leftIconIsHovered = !0),
      onMouseleave: o[5] || (o[5] = (r) => e.leftIconIsHovered = !1)
    }, null, 8, ["aria-label", "color", "class"]), [
      [f, e.showLeftArrow]
    ]),
    e.isWrapper ? g(e.$slots, "default", { key: 0 }, void 0, !0) : p("", !0),
    a(s(n, {
      "aria-label": e.navigationArrowsAriaLabel,
      ref: "rightArrowRef",
      symbol: "chevron-left",
      color: e.rightIconIsHovered || e.rightIconIsInFocus ? e.getComputedStyleValue("--hobi-color-white") : e.getComputedStyleValue("--hobi-color-grey-900"),
      size: "20",
      class: t(["hobi-navigation-arrow hobi-navigation-arrow--right tw--translate-y-2/4 tw-right-0 tw-top-2/4 tw--translate-y-1/2 tw-absolute tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center", {
        "hobi-wrapper": e.isWrapper,
        "hobi-navigation-arrow--has-border": e.hasBorder,
        "hobi-navigation-arrow--has-hover": e.rightIconIsHovered
      }]),
      onClick: o[6] || (o[6] = (r) => e.$emit("navigation-arrows:click-right")),
      onKeypress: o[7] || (o[7] = l((r) => e.$emit("navigation-arrows:click-right"), ["enter"])),
      onFocus: o[8] || (o[8] = (r) => e.handleFocus(r, "right")),
      onBlur: o[9] || (o[9] = (r) => e.handleFocus(r, "right")),
      onMouseover: o[10] || (o[10] = (r) => e.rightIconIsHovered = !0),
      onMouseleave: o[11] || (o[11] = (r) => e.rightIconIsHovered = !1)
    }, null, 8, ["aria-label", "color", "class"]), [
      [f, e.showRightArrow]
    ])
  ], 2);
}
const S = /* @__PURE__ */ m(b, [["render", y], ["__scopeId", "data-v-e3cea497"]]);
export {
  S as default
};
